import { ref } from "#imports";
export const activeTooltip = ref();
